import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  title: {
    id: 'product_jp_reassurance_customer_support_title',
    defaultMessage: 'Reliable domestic customer support',
  },
  delay: {
    id: 'product_jp_reassurance_customer_support_delay',
    defaultMessage: '\\ Within 1 business day /',
  },
  content: {
    id: 'product_jp_reassurance_customer_support_content',
    defaultMessage:
      "Our support team in Japan will get back to you within one business day. For any questions, or to make a return or repair request, simply visit your 'Order History' page and contact us through 'Contact Us.",
  },
  hours: {
    id: 'product_jp_reassurance_customer_support_hours',
    defaultMessage:
      'Business Hours: Mon. - Sats. & Holidays (9:00 AM - 6:00 PM)',
  },
  phone: {
    id: 'product_jp_reassurance_customer_support_phone',
    defaultMessage: 'Phone support：0120-938-647',
  },
} as Record<string, I18nDefinition>
